import { useState, useEffect } from 'react';

interface Project {
  id: number;
  title: string;
  image: string;
  category: string;
  description: string;
  features: string[];
}

const ProjectCarousel = () => {
  const [flippedCards, setFlippedCards] = useState<number[]>([]);
  const [scrollPosition, setScrollPosition] = useState(0);

  const projects: Project[] = [
    {
      id: 1,
      title: 'Modern Restaurant Website',
      image: 'https://public.readdy.ai/ai/img_res/aa0d9b9cdd5c766cb8484ba0e2d4a6b1.jpg',
      category: 'Website Design',
      description: 'Elegant restaurant website with online ordering and reservation system',
      features: ['Responsive Design', 'Online Menu', 'Reservation System', 'Photo Gallery']
    },
    {
      id: 2,
      title: 'Fitness Studio Landing Page',
      image: 'https://readdy.ai/api/search-image?query=fitness%20gym%20landing%20page%20design%20mockup%20on%20computer%20screen%2C%20energetic%20workout%20website%20layout%2C%20professional%20web%20design%20interface%2C%20bright%20motivational%20colors%2C%20modern%20digital%20design%20aesthetic&width=400&height=300&seq=web2&orientation=landscape',
      category: 'Landing Page',
      description: 'High-converting landing page for fitness studio membership sign-ups',
      features: ['Lead Capture Form', 'Class Schedule', 'Trainer Profiles', 'Success Stories']
    },
    {
      id: 3,
      title: 'Fashion Brand PPC Ad',
      image: 'https://readdy.ai/api/search-image?query=fashion%20brand%20PPC%20advertisement%20design%20mockup%2C%20stylish%20clothing%20ad%20campaign%2C%20professional%20digital%20marketing%20creative%2C%20bright%20colorful%20background%2C%20modern%20advertising%20design%20aesthetic&width=400&height=300&seq=ppc1&orientation=landscape',
      category: 'PPC Campaign',
      description: 'Eye-catching PPC ad campaign for fashion brand seasonal collection',
      features: ['A/B Testing', 'Audience Targeting', 'Conversion Tracking', 'ROI Optimization']
    },
    {
      id: 4,
      title: 'Real Estate Website',
      image: 'https://readdy.ai/api/search-image?query=luxury%20real%20estate%20website%20design%20mockup%20on%20desktop%20screen%2C%20elegant%20property%20listing%20layout%2C%20professional%20web%20design%20interface%2C%20bright%20clean%20background%2C%20contemporary%20digital%20design%20aesthetic&width=400&height=300&seq=web3&orientation=landscape',
      category: 'Website Design',
      description: 'Luxury real estate website with virtual tours and property search',
      features: ['Property Listings', 'Virtual Tours', 'Advanced Search', 'Agent Profiles']
    },
    {
      id: 5,
      title: 'Local Business Landing',
      image: 'https://readdy.ai/api/search-image?query=local%20business%20landing%20page%20design%20mockup%20on%20laptop%20screen%2C%20professional%20service%20website%20layout%2C%20clean%20web%20design%20interface%2C%20bright%20colorful%20background%2C%20modern%20digital%20design%20aesthetic&width=400&height=300&seq=web4&orientation=landscape',
      category: 'Landing Page',
      description: 'Local service business landing page optimized for local SEO',
      features: ['Local SEO', 'Contact Forms', 'Service Areas', 'Customer Reviews']
    },
    {
      id: 6,
      title: 'Tech Startup PPC Ad',
      image: 'https://readdy.ai/api/search-image?query=technology%20startup%20PPC%20advertisement%20design%20mockup%2C%20innovative%20tech%20ad%20campaign%2C%20professional%20digital%20marketing%20creative%2C%20bright%20vibrant%20background%2C%20modern%20advertising%20design%20aesthetic&width=400&height=300&seq=ppc2&orientation=landscape',
      category: 'PPC Campaign',
      description: 'Innovative PPC campaign for tech startup product launch',
      features: ['Multi-Platform Ads', 'Retargeting', 'Analytics Dashboard', 'Budget Optimization']
    },
    {
      id: 7,
      title: 'E-commerce Website',
      image: 'https://readdy.ai/api/search-image?query=modern%20e-commerce%20website%20design%20mockup%20on%20computer%20screen%2C%20online%20store%20layout%20with%20product%20displays%2C%20professional%20web%20design%20interface%2C%20bright%20colorful%20background%2C%20contemporary%20digital%20design%20aesthetic&width=400&height=300&seq=web5&orientation=landscape',
      category: 'Website Design',
      description: 'Full-featured e-commerce platform with secure checkout',
      features: ['Product Catalog', 'Shopping Cart', 'Payment Gateway', 'Order Tracking']
    },
    {
      id: 8,
      title: 'Healthcare Landing Page',
      image: 'https://readdy.ai/api/search-image?query=healthcare%20medical%20landing%20page%20design%20mockup%20on%20laptop%20screen%2C%20professional%20medical%20website%20layout%2C%20clean%20web%20design%20interface%2C%20bright%20trustworthy%20background%2C%20modern%20digital%20design%20aesthetic&width=400&height=300&seq=web6&orientation=landscape',
      category: 'Landing Page',
      description: 'Professional healthcare landing page with appointment booking',
      features: ['Appointment Booking', 'Service Information', 'Insurance Details', 'Patient Portal']
    },
    {
      id: 9,
      title: 'Restaurant PPC Campaign',
      image: 'https://readdy.ai/api/search-image?query=restaurant%20food%20PPC%20advertisement%20design%20mockup%2C%20delicious%20food%20ad%20campaign%2C%20professional%20digital%20marketing%20creative%2C%20bright%20appetizing%20background%2C%20modern%20advertising%20design%20aesthetic&width=400&height=300&seq=ppc3&orientation=landscape',
      category: 'PPC Campaign',
      description: 'Mouth-watering PPC ads driving restaurant reservations',
      features: ['Geo-Targeting', 'Time-Based Ads', 'Special Offers', 'Click-to-Call']
    },
    {
      id: 10,
      title: 'Professional Services Site',
      image: 'https://readdy.ai/api/search-image?query=professional%20services%20website%20design%20mockup%20on%20desktop%20screen%2C%20corporate%20business%20layout%2C%20professional%20web%20design%20interface%2C%20bright%20clean%20background%2C%20contemporary%20digital%20design%20aesthetic&width=400&height=300&seq=web7&orientation=landscape',
      category: 'Website Design',
      description: 'Corporate website for professional services firm',
      features: ['Team Directory', 'Case Studies', 'Client Portal', 'Blog Integration']
    }
  ];

  // Duplicate projects for seamless loop
  const duplicatedProjects = [...projects, ...projects, ...projects];

  useEffect(() => {
    const interval = setInterval(() => {
      setScrollPosition((prev) => {
        const newPosition = prev + 1;
        // Reset when we've scrolled through one full set
        if (newPosition >= (projects.length * 320)) {
          return 0;
        }
        return newPosition;
      });
    }, 30);

    return () => clearInterval(interval);
  }, [projects.length]);

  const handleCardClick = (id: number) => {
    setFlippedCards((prev) => {
      if (prev.includes(id)) {
        return prev.filter((cardId) => cardId !== id);
      }
      return [...prev, id];
    });
  };

  return (
    <div className="relative bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-12 border border-purple-200 overflow-hidden">
      <div className="relative h-96 overflow-hidden">
        <div 
          className="flex gap-6 absolute"
          style={{
            transform: `translateX(-${scrollPosition}px)`,
            transition: 'transform 0.03s linear'
          }}
        >
          {duplicatedProjects.map((project, index) => {
            const isFlipped = flippedCards.includes(project.id);
            
            return (
              <div
                key={`${project.id}-${index}`}
                className="flex-shrink-0 w-80 h-80 cursor-pointer perspective-1000"
                onClick={() => handleCardClick(project.id)}
              >
                <div 
                  className={`relative w-full h-full transition-transform duration-700 transform-style-3d ${
                    isFlipped ? 'rotate-y-180' : ''
                  }`}
                  style={{
                    transformStyle: 'preserve-3d',
                    transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
                  }}
                >
                  {/* Front Side - Image */}
                  <div 
                    className="absolute w-full h-full backface-hidden rounded-2xl overflow-hidden shadow-xl"
                    style={{ backfaceVisibility: 'hidden' }}
                  >
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                      <div className="text-sm font-medium bg-purple-500 px-3 py-1 rounded-full inline-block mb-2">
                        {project.category}
                      </div>
                      <h3 className="text-xl font-bold mb-2">{project.title}</h3>
                      <p className="text-sm text-gray-200">Click to see details</p>
                    </div>
                  </div>

                  {/* Back Side - Details */}
                  <div 
                    className="absolute w-full h-full backface-hidden rounded-2xl overflow-hidden shadow-xl bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 p-4"
                    style={{ 
                      backfaceVisibility: 'hidden',
                      transform: 'rotateY(180deg)'
                    }}
                  >
                    <div className="h-full flex flex-col justify-between text-white">
                      <div>
                        <div className="text-xs font-medium bg-white/20 px-2 py-1 rounded-full inline-block mb-2">
                          {project.category}
                        </div>
                        <h3 className="text-lg font-bold mb-2 leading-tight">{project.title}</h3>
                        <p className="text-white/90 mb-4 text-xs leading-relaxed">{project.description}</p>
                      </div>
                      
                      <div className="flex-1">
                        <h4 className="font-bold mb-2 text-sm">Key Features:</h4>
                        <div className="space-y-1">
                          {project.features.map((feature, idx) => (
                            <div key={idx} className="flex items-center">
                              <i className="ri-check-line text-yellow-300 mr-2 text-xs"></i>
                              <span className="text-xs">{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="text-center mt-2">
                        <p className="text-xs text-white/80">Click to flip back</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Instruction */}
      <div className="text-center mt-8">
        <p className="text-gray-600 text-lg">
          <i className="ri-hand-coin-line mr-2"></i>
          Click any project to see details
        </p>
      </div>

      {/* Legend */}
      <div className="flex justify-center gap-4 mt-6 flex-wrap">
        <div className="flex items-center gap-2 bg-purple-100 px-4 py-2 rounded-full">
          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
          <span className="text-sm font-medium text-gray-700">Website Design</span>
        </div>
        <div className="flex items-center gap-2 bg-pink-100 px-4 py-2 rounded-full">
          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
          <span className="text-sm font-medium text-gray-700">Landing Pages</span>
        </div>
        <div className="flex items-center gap-2 bg-orange-100 px-4 py-2 rounded-full">
          <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
          <span className="text-sm font-medium text-gray-700">PPC Campaigns</span>
        </div>
      </div>
    </div>
  );
};

export default ProjectCarousel;
